export const HISTORY_KEY = 'search_history';
export const MAX_HISTORY = 10;
